import Vue from 'vue'
import VueRouter from 'vue-router'
import GroupPage from "@/pages/GroupPage.vue";
import InstitutesPage from "@/pages/InstitutesPage.vue";
import CalendarWeek from "@/pages/CalendarWeek.vue";
import SearcheBugs from '@/pages/SearcheBugs.vue';
import NotFoundPage from "@/pages/NotFoundPage.vue";
import Test from "@/pages/TestCalendar.vue";

Vue.use(VueRouter)

const routes = [
  {name: 'institutes', component: InstitutesPage, path: '/'},
  {name: 'group', component: GroupPage, path: '/group/:group'},
  {name: 'teacher', component: GroupPage, path: '/teacher/:teacher'},
  {name: 'calendarWeek', component: CalendarWeek, path: '/calendar'},
  {name: 'searchbugs', component: SearcheBugs, path: '/bugs'},
  {name: 'test', component: Test, path: '/test'},
  {name: 'notFound', component: NotFoundPage, path: '*'},
]

const router = new VueRouter({
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes
})

export default router
